import { ApiResponse, createAuthenticatedApiCall } from '../utils/apiCall';
import type { ApiRequestConfig } from './models/ApiRequestConfig';

interface ChangeCoverToSingleRequest {
    travelId: string;
    changeCoverOn: string;
    source: 'Web';
    NewContractTypeName: string;
    SelectedCovers: never[];
}

interface ChangeCoverToSingleResponse {
    Message?: string;
    StatusCode?: string;
    errors?: string;
}

export interface ChangeCoverToSingleConfig extends ApiRequestConfig {
    travelId: string;
    contractType: string;
}

export type ChangeCoverToSingle = ApiResponse<ChangeCoverToSingleResponse>;

export const changeCoverToSingle = async (config: ChangeCoverToSingleConfig): ChangeCoverToSingle => {
    const { travelId, contractType, apis } = config;

    const body: ChangeCoverToSingleRequest = {
        travelId,
        changeCoverOn: new Date().toISOString(),
        source: 'Web',
        NewContractTypeName: contractType,
        SelectedCovers: [],
    };

    const queryParams = new URLSearchParams({
        product: 'TravelInsurance',
    });

    return await createAuthenticatedApiCall<ChangeCoverToSingleResponse>({
        baseUrl: `${apis.methods.changeCover}?${queryParams}`,
        method: 'PUT',
        body,
        config,
    });
};
